import React from 'react'
import PropTypes from 'prop-types'
import { getCurrentRole } from '../../../../util'
import '../../../../assets/css/components/StudentHomepage/StudentDashboard/StudentDashboard.css'
import '../../../../assets/css/components/StudentHomepage/StudentDashboard/ClassToGameCard.css'
import { AssetHost } from '../../../../config'

/*This component is reponsible for the class selection and assignment display on the student dashboad.
To make this component more flexible, it should recieve three props:

1. currentUser
2. componentSize
3. classAssignmentData: and should be in the following form: 

[
	{ sectionName: string, sectionId: string, instructor: [string], assignments: [current assignments]},
	...
]

If this component is to be used elsewhere that is not student/kid, refactor to change the component names,
and css related names accordingly, AND move this component to the Shared folder.
 */
const StudentDashboard = ({ currentUser, componentSize, classAssignmentData }) => {
	const userRole = getCurrentRole(currentUser)
	return (
		<main className='studentDashboard'>
			<div className='studentDashboard-header'>
				<h2 className='studentDashboard-title'>Select a Class to Play</h2>
				{/* Join Class UI hidden until we implement the functionality */}
				{/* {userRole === 'STUDENT' && (
					<button className='studentDashboard-function _joinClass'>+ Join Class</button>
				)} */}
				{/* link parent feature is not yet implemented */}
				{/* <button className='studentDashboard-function _linkParent'>+ Link Parent</button> */}
			</div>
			<ul
				className={`studentDashboard-classList${
					componentSize.componentWidth < 675 ? '_smallScreen' : ''
				}`}>
				{classAssignmentData.map((classItem, index) => {
					return (
						<li
							key={classItem.sectionName + index}
							className='studentDashboard-classListItem'>
							<ClassToGameCard classAssignment={classItem} />
						</li>
					)
				})}
			</ul>
		</main>
	)
}

StudentDashboard.propTypes = {
	currentUser: PropTypes.object.isRequired,
	componentSize: PropTypes.object,
	classAssignmentData: PropTypes.array.isRequired
}

// ClassToGameCard - move to src/component/Shared if this component needs to be shared among other components in the future
const ClassToGameCard = ({ classAssignment }) => {
	const calculateAssignmentText = assignmentList => {
		if (assignmentList.length === 0) {
			return 'No assignments today'
		} else if (assignmentList.length === 1) {
			return <span>{assignmentList[0]}</span>
		} else {
			return (
				<React.Fragment>
					<span>{assignmentList[0]}</span>
					&nbsp;and {`${assignmentList.length - 1}`} other assignments
				</React.Fragment>
			)
		}
	}

	return (
		<a
			href={`${AssetHost()}?sectionId=${classAssignment.sectionId}`}
			alt={`link to enter tytonline game with class${classAssignment.sectionId}`}
			target='_blank'
			className='classCard-link'>
			{classAssignment.assignments.length > 0 && (
				<div className='classCard-numberBubble'>{classAssignment.assignments.length}</div>
			)}
			<div className='classCard-header'>
				<h3 className='classCard-title'>{classAssignment.sectionName}</h3>
				<p className='classCard-educatorName'>
					{classAssignment.instructor.map((instructorName, index) => (
						<span key={instructorName + index}>{instructorName}</span>
					))}
				</p>
			</div>
			<div className='classCard-assignmentText'>
				<p className='classCard-assignmentText-text'>
					{calculateAssignmentText(classAssignment.assignments)}
				</p>
			</div>
		</a>
	)
}

ClassToGameCard.propTypes = {
	classAssignment: PropTypes.object.isRequired
}

export default StudentDashboard
